<template>
  <validation-provider
    #default="{ errors }"
    name="type"
    :rules="{
      required: requiredField,
    }"
  >
    <b-form-group
      :label="label"
      label-for="type"
      :label-class="labelClass"
    >
      <v-select
        id="type"
        v-model="type"
        :class="errors.length > 0 ? 'error-select' : ''"
        :filter="fuseSearch"
        label="name"
        :options="dataOptions"
        :placeholder="'Tipo da Assistência'"
        :disabled="readonly"
        :clearable="!readonly"
        @open="onCreate()"
      >
        <template #option="{ name }">
          <span>{{ name }}</span>
        </template>

        <template #selected-option="{ name }">
          <span>{{ name }}</span>
        </template>

        <template #no-options>
          Não há opções de Tipo da Assistência.
        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </b-form-group>
  </validation-provider>
</template>
<script>
import {
  BFormGroup,
} from 'bootstrap-vue'

import {
  ValidationProvider,
} from 'vee-validate'

import {
  required,
} from '@validations'

import vSelect from 'vue-select'
import Fuse from 'fuse.js'
import syslic from '@/syslic'
import truncate from '@/components/utils/filters/truncate'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  filters: {
    truncate,
  },
  model: {
    prop: 'typeValue',
    event: 'typeChange',
  },
  props: {
    typeValue: {
      type: [Object, String],
      required: false,
      default: null,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: [String, Number],
      required: false,
      default: 'Tipo da Assistência',
    },
    labelClass: {
      type: [String, Array],
      required: false,
      default: '',
    },
  },
  data() {
    const dataOptions = []
    const newTypeValue = this.typeValue

    return {
      dataOptions,
      required,
      newTypeValue,
    }
  },
  computed: {
    type: {
      get() {
        return this.newTypeValue
      },
      set(value) {
        this.newTypeValue = value
        this.$emit('typeChange', this.newTypeValue)
      },
    },
  },
  watch: {
    typeValue(newVal) {
      this.newTypeValue = newVal
    },
  },
  created() {
    this.onCreate()
  },
  methods: {
    onCreate() {
      syslic
        .order
        .assistance
        .type
        .fetchAllTypes()
        .then(response => {
          this.dataOptions = response.data.results
          this.$emit('ready', true)
        })
        .catch(() => {
          this.$emit('ready', true)
        })
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['name'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style lang="scss" scoped>
.v-select {
  background-color: #fff;
}
</style>
